import { apiSaveTracking } from "../../api/ApiTracking";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ComponentTracking = (props) => {
  let location = useLocation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail, ReduxUserNom, ReduxUserPrenom, ReduxUserPicture, ReduxUserIdColidee } =
    useSelector((state) => state.ReduxUser);

  useEffect(() => {
    const isWebview = /easygouv/.test(window.navigator.userAgent.toLowerCase());

    const formdata = {
      idColidee: ReduxUserIdColidee,
      nom: ReduxUserNom,
      prenom: ReduxUserPrenom,
      email: ReduxUserEmail,
      url: window.location.href,
      profile_pic: ReduxUserPicture,
      title: props.trackingTitle ? props.trackingTitle : window.location.href,
      traceurNavigation: props.traceurNavigation,
      device: isWebview ? "application" : "navigateur",
    };
    apiSaveTracking(ReduxInstance._id, formdata);
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  return <></>;
};

export default ComponentTracking;
